




import Vue, { PropType } from 'vue'
import _ from 'lodash'

type Lang = 'ja' | 'en'

/**
 * Pay.jp Checkout Component.
 * @see https://pay.jp/docs/checkout
 */
export default Vue.extend({
  name: 'PayjpButton',
  props: {
    /** あなたの公開鍵  */
    publicKey: {
      type: String,
      required: true,
    },
    /** PAY.JPで発行したOAuth Client ID  */
    clientId: {
      type: String,
      required: false,
    },
    /** trueの場合、カード情報フォーム入力完了後に自動的に送信(form.submit())しない */
    partial: {
      type: Boolean,
      default: false,
    },
    /* カード情報入力フォームを開くのボタンのテキスト */
    text: {
      type: String,
      required: false,
    },
    /**	カード情報入力フォーム内の送信ボタンのテキスト */
    submitText: {
      type: String,
      required: false,
    },
    /** 作成されたトークンがセットされるinput name(hidden) */
    tokenName: {
      type: String,
      default: 'payjp-token',
    },
    /** エラーにより画面に戻ってきた場合などに、再入力をさせないために作成済みのトークンを入れるパラメーター( data-partial が true の場合のみ機能する ) */
    previousToken: {
      type: String,
      required: false,
    },
    /* メッセージなどの表示言語( ja と en が指定可能) */
    lang: {
      type: String as PropType<Lang>,
      default: 'ja',
    },
    /** トークンの作成に成功したときに、PAY.JPサーバーからのレスポンスを引数に呼び出される関数名 */
    onCreated: {
      type: String,
      default: 'onTokenCreated',
    },
    /** トークンの作成に失敗したときに、ステータスコードを第一引数、エラーオブジェクトを第二引数として呼び出される関数名 */
    onFailed: {
      type: String,
      default: 'onTokenFailed',
    },
    /** カード名義のplaceholderにセットされる値 */
    namePlaceholder: {
      type: String,
      default: 'TARO YAMADA',
    },
  },
  data() {
    return {
      scriptEl: HTMLScriptElement,
    }
  },
  mounted() {
    const w = window as any
    w[this.onCreated] = this.onTokenCreated
    w[this.onFailed] = this.onTokenFailed

    const attrs: { [key: string]: string } = {
      src: 'https://checkout.pay.jp/',
      class: 'payjp-button',
      'data-key': this.publicKey,
      'data-payjp': this.clientId,
      'data-partial': String(this.partial),
      'data-text': this.text,
      'data-submit-text': this.submitText,
      'data-token-name': this.tokenName,
      'data-previous-token': this.previousToken,
      'data-lang': this.lang,
      'data-on-created': this.onCreated,
      'data-on-failed': this.onFailed,
      'data-name-placeholder': this.namePlaceholder,
    }

    this.$data.scriptEl = document.createElement('script')
    _.forEach(attrs, (v, k) => {
      if (v !== undefined) {
        this.$data.scriptEl.setAttribute(k, v)
      }
    })
    this.$el.appendChild(this.$data.scriptEl)
  },
  beforeDestroy() {
    const w = window as any
    delete w[this.onCreated]
    delete w[this.onFailed]
    // delete iframe
    const iframeEl = document.getElementById('payjp-checkout-iframe')
    iframeEl?.parentElement?.remove()
    this.$el.removeChild(this.$data.scriptEl)
    // delete PayjpCheckout object
    delete w.PayjpCheckout
  },
  methods: {
    onTokenCreated() {
      const token = (document.getElementsByName(
        this.tokenName
      )[0] as HTMLInputElement).value
      this.$emit('created', token)
    },
    onTokenFailed(code: number, error: Error) {
      this.$emit('failed', { code, error })
    },
  },
})
